const single_sign_on = {
    forbidden_domains: 'Les domaines de messagerie publique ne sont pas autorisés.',
    duplicated_domains: 'Il existe des domaines en double.',
    invalid_domain_format: 'Format de domaine invalide.',
    duplicate_connector_name: 'Le nom du connecteur existe déjà. Veuillez choisir un nom différent.',
};
export default Object.freeze(single_sign_on);
